import { useQuery } from '@tanstack/react-query'
import { useAuth } from 'src/contexts/auth'
import { PastureController } from 'src/controllers/pasture.controller'
import { PastureDto } from 'src/dto/pasture.dto'

const pastureController = new PastureController()

export function useGetPastureById(id: string) {
  const { userFarm: farmId } = useAuth()

  return useQuery<PastureDto, Error>({
    queryKey: ['getPastureById', farmId, id],
    queryFn: () => pastureController.getPastureById(farmId!, id),
    enabled: !!farmId && !!id
  })
}
